import React from 'react';
import { Button, Box, Divider, Paper, Fade, Grow } from "@material-ui/core";
import { calendar, clock, mail, bell, home, admin, vodafoneIcon, admintoolbox } from "../assets/img/index";
import { formatDate as dateFormatter, formatTime as timeFormatter } from '../utility/utility';
import { Footercomponent } from "../common/Footer";
//#region utility function divider, header, footer, toolbox

//#region Divider
// adds spacer with height specified
// usage <Divide heightInPx={<number>}
const Divide = ({ classes, heightInPx }) => {
    const style = { height: heightInPx + 'px' }
    return (
        <div className={classes.width100} style={style}></div>
    )
}
//#endregion

//#region header
const Header = () => {
    return (
        <React.Fragment>
            <Box flexDirection="row" p={1} justifyContent="left" style={{ background: 'white', minHeight: '2vh' }}>
                <a href="https://www.unitymedia.de">
                    <img src={vodafoneIcon} height={"45px"} width={"45px"} />
                </a>
            </Box>
        </React.Fragment>
    )
}
//#endregion



//#region toolbox
/* @params 
icon: icon to be displayed in the toolbox
text: text to be displayed-> fontweight normal
heading: header to toolbox-> font weight Bold
*/
const ToolBox = ({ classes, icon, text, heading, supplierInfo, textdesc }) => {
    return (
        <React.Fragment>
            <Grow in={true} timeout={500}>
                <Box
                    boxShadow={1}
                    borderColor="secondary.main"
                    borderRadius="borderRadius"
                    display="flex"
                    flexDirection="row"
                    mx="auto"
                    p={2}
                    justifyContent="left"
                    alignItems="center"
                    style={{ borderLeft: '10px solid #ffd600', borderBottom: '2px solid #ffd600', borderRight: '2px solid #ffd600' }}>
                    <img src={icon} alt="tools icon" className={classes.listImage} style={{ placeSelf: 'self-start' }} />
                    <div className={classes.swa_flexBoxColumn + ' wa__utility--lH15'}>
                        <h4 className={classes.margin0}>{heading}</h4>
                        <p className={classes.margin0}>{text}</p>
                        <p className={classes.margin0}>{textdesc}</p>
                        <p className={classes.margin0}>Kontakt*: </p>
                        <p className={classes.margin0}>{supplierInfo.seCompany}</p>
                        <p className={classes.margin0}>{supplierInfo.sePhone}</p>
                    </div>
                </Box>
            </Grow>
            <p>* zum Ortstarif</p>
        </React.Fragment>
    )
}
//#endregion

//#endregion

//#region Confirmation Page Content
//#region desc
// classes: CSS styling classes
// showConfirm: state from parent to hide confirmation page 
//#endregion
export function confirmation(classes: any, showConfirm: Function, selectedSlot: any, showSlots: Function, supplierInfo: any, refetch: Function) {

    const returnHome = () => {
        showConfirm(false);
        showSlots(false);
        refetch();
    }

    const appointmentDate = selectedSlot.begin;
    const appointmentTimeBegin = selectedSlot.begin;
    const appointmentTimeEnd = selectedSlot.end;
    const toolBoxHeader = 'Unser Service-Partner für dich';
    const toolBoxText = 'Der Techniker der Firma handelt im Auftrag von Vodafone.';
    const step1 = 'Du bekommst bald eine Termin-Bestätigung per SMS oder E-Mail.';
    const step2 = 'Einen Tag vor deinem Termin bekommst du von uns eine Erinnerung.';
    const step3 = 'Stell bitte sicher, dass der Techniker beim Termin freien Zugang zu diesen Anschlüssen hat:';
    const step3a = 'Kabel-Anschlussdose in deiner Wohnung';
    const step3b = 'Hausverteilanlage (oft im Keller, bitte Hausmeister rechtzeitig informieren, falls nicht zugänglich)';
    const step4 = 'Der Service-Techniker kommt im vereinbarten Zeitfenster zu dir. Er braucht normalerweise 1-2 Stunden.';

    const toolBoxText2 = 'Du möchtest deinen Termin doch noch ändern? Über die Stautusübersicht kannst du den Termin anpassen.';
    const toolBoxIcon = admin;
    return <div className={classes.mainImage + ' ' + classes.width100} style={{ display: 'block' }}>
        <Header />
        <Divider />
        <div className="wa__utility--p1 wa__containerfw--center" style={{ minHeight: '90vh' }}>
            <Paper elevation={5} variant={"outlined"} className="wa__utility--p1 wa__containerfw--center" >

                <div className="wa__containerfw--center ">
                    <div className="wa__utility--mtmb1  wa__utility--tac">
                        <h2 className={classes.flexItem + ' ' + classes.headingRed}>Terminvereinbarung</h2>
                        <h3 className={classes.flexItem + ' ' + classes.headingNormal}>Service-Techniker</h3>
                    </div>
                    <div className="wa__utility--mb1  wa__utility--tac">
                        <h3 className="wa__copy__heading--small">Das hat geklappt.</h3>
                        <h5 className={classes.flexItem + ' ' + classes.headingNormal}>Dein Termin wurde gebucht.</h5>
                    </div>
                </div>
                <div className="wa__containerfw  wa__utiity--m0auto wa__utility--mb3 ">
                    <Fade in={true} timeout={500}>
                        <div className="wa__utiity--m0auto">
                            <h4 className="wa__copy__titlecopy">Dein Termin</h4>
                            <div className="wa__ticketapp__appointmentslot">
                                <div className="wa__ticketapp__appointmentslot__item">
                                    <img src={calendar} alt="calendar svg here" className="wa__ticketapp__appointmentslot__item__image" />
                                    <p className="wa__ticketapp__appointmentslot__item__copy">{dateFormatter(appointmentDate)}</p>
                                </div>
                                <div className="wa__ticketapp__appointmentslot__item">
                                    <img src={clock} alt="clock svg here" className="wa__ticketapp__appointmentslot__item__image" />
                                    <p className="wa__ticketapp__appointmentslot__item__copy">{timeFormatter(appointmentTimeBegin, appointmentTimeEnd)}</p>
                                </div>
                            </div>
                        </div>
                    </Fade>

                    <Grow
                        in={true}
                        style={{ transformOrigin: '0 0 0' }}>
                        <div className="wa__utiity--m0auto">
                            <h3 className="wa__copy__titlecopy">So geht's weiter</h3>


                            <ol className="wa__ticketapp__bookedinfoguide">
                                <div className="wa__ticketapp__bookedinfoguide__item">
                                    <div className="wa__ticketapp__bookedinfoguide__item__image">
                                        <img src={mail} alt="mail svg here" className={classes.listImage} />
                                    </div>
                                    <li className="wa__ticketapp__bookedinfoguide__item__copy"> {step1}</li>
                                </div>
                                <div className="wa__ticketapp__bookedinfoguide__item">
                                    <div className="wa__ticketapp__bookedinfoguide__item__image">
                                        <img src={bell} alt="bell svg here" />
                                    </div>
                                    <li className="wa__ticketapp__bookedinfoguide__item__copy">{step2}</li>
                                </div>
                                <div className="wa__ticketapp__bookedinfoguide__item">
                                    <div className="wa__ticketapp__bookedinfoguide__item__image">
                                        <img src={home} alt="home svg here" />
                                    </div>
                                    <li className="wa__ticketapp__bookedinfoguide__item__copy">{step3}
                                        <ol className="wa__utility--pt1">
                                            <li className="wa__ticketapp__bookedinfoguide__item__copy" >{step3a}</li>
                                            <li className="wa__ticketapp__bookedinfoguide__item__copy"  >{step3b}</li>
                                        </ol>
                                    </li>
                                </div>
                                <div className="wa__ticketapp__bookedinfoguide__item">
                                    <div className="wa__ticketapp__bookedinfoguide__item__image">
                                        <img src={admintoolbox} alt="tool svg here" />
                                    </div>
                                    <li className="wa__ticketapp__bookedinfoguide__item__copy">{step4}</li>
                                </div>
                            </ol>

                        </div>
                    </Grow>
                    <div className="wa__button__primary wa__utility--centerobject">
                        <Button variant="contained" size="large" onClick={returnHome}>
                            Zurück zur Übersicht
                </Button>
                    </div>
                </div>

                <div className="wa__utility--mt1">
                    <ToolBox icon={admintoolbox} text={toolBoxText} textdesc={toolBoxText2} heading={toolBoxHeader} supplierInfo={supplierInfo} classes={classes} />
                </div>


                <Divide heightInPx={30} classes={classes} />

            </Paper>
        </div>
        {/* <Divide heightInPx={40} classes={classes} /> */}
        <Footercomponent />

    </div>
}
//#endregion
